// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { z } from 'zod';
export const explorerNotebookId = (z.number());
export const explorerNotebook = z.object({
    id: explorerNotebookId,
    owner_operator_id: operatorId,
    name: z.string(),
    is_scratch: z.boolean(),
    state: z.unknown(),
    is_shared: z.boolean(),
    created_at: z.date(),
    updated_at: z.date(),
});
export const explorerNotebookInitializer = z.object({
    id: explorerNotebookId.optional(),
    owner_operator_id: operatorId,
    name: z.string().optional(),
    is_scratch: z.boolean().optional(),
    state: z.unknown().optional(),
    is_shared: z.boolean().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
export const explorerNotebookMutator = z.object({
    id: explorerNotebookId.optional(),
    owner_operator_id: operatorId.optional(),
    name: z.string().optional(),
    is_scratch: z.boolean().optional(),
    state: z.unknown().optional(),
    is_shared: z.boolean().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
//# sourceMappingURL=ExplorerNotebook.js.map